import http from "@/services/http";
import { VoiceList, IAddVoiceParams, IEditVoiceParams } from "@/types/voice";

// 获取声纹列表
export async function getVoiceList(page: number) {
  const queryStr = `page=${page}&size=20`;
  const res = await http.get<VoiceList>(
    `/api/auth/voiceprint/page?${queryStr}`
  );
  return res.data;
}

// 添加声纹
export async function addVoice(params: IAddVoiceParams, signal: AbortSignal) {
  const res = await http.post<boolean>("/api/auth/voiceprint/enroll", params, {
    signal, // 添加 signal
  });
  return res.data;
}

// 编辑声纹
export async function editVoice(
  voicePrintId: string,
  params: IEditVoiceParams
) {
  const res = await http.post<boolean>(
    `/api/auth/voiceprint/${voicePrintId}`,
    params
  );
  return res.data;
}

// 删除声纹
export async function deleteVoice(voicePrintId: string) {
  const res = await http.delete<boolean>(
    `/api/auth/voiceprint/${voicePrintId}`
  );
  return res.data;
}

// 校验声纹是否已存在
export async function checkVoice(roleName: string) {
  const res = await http.get<boolean>(
    `/api/auth/voiceprint/check?roleName=${roleName}`
  );
  return res.data;
}
